module.exports = __webpack_public_path__ + "static/media/breed.85ebfa2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/icons/breed.svg
// module id = 330
// module chunks = 0